import { basicValidations } from "./invValidations";
import { standardValidations } from "./defaultValidations";

export enum ProductCategories {
  INV = "INV",
  SAV = "SAV",
  PENS = "PENS",
  CHILD = "CHILD"
}

const defaultInitialValues = {
  frequencyCode: undefined,
  durationInYears: undefined,
  premiumPerFreq: "",
  sumAssured: "",
  investmentProfile: undefined,
  payments: undefined
};

const invInitialValues = {
  ...defaultInitialValues,
  frequencyCode: "Annual",
  investmentProfile: "CAUTIOUS",
  sumAssured: undefined
};

const invConfig = {
  initialValues: invInitialValues,
  fields: [
    {
      headerTrKey: "form.contributionPeriod",
      id: "payments",
      type: "Select",
      rowNumber: 3,
      dictname: "PAYMENTS",
      dictType: "years"
    },
    {
      headerTrKey: "form.durationAgreement",
      id: "durationInYears",
      type: "Select",
      rowNumber: 4,
      dictname: "DURATION_IN_YEARS",
      dictType: "years"
    },
    {
      headerTrKey: "form.annualSubscription",
      id: "premiumPerFreq",
      rowNumber: 5,
      type: "Input"
    }
  ] as DefaultConfigState[],
  tableType: `Basic`
};

const defaultConfig = {
  initialValues: defaultInitialValues,
  fields: [
    {
      headerTrKey: "form.frequencyPayments",
      id: "frequencyCode",
      type: "Select",
      rowNumber: 3,
      dictname: "PREMIUM_FREQUENCY",
      dictType: "translate"
    },
    {
      headerTrKey: "form.durationMainAgreement",
      id: "durationInYears",
      type: "Select",
      rowNumber: 4,
      dictname: "DURATION_IN_YEARS",
      dictType: "years"
    },
    {
      headerTrKey: "form.MainContractContribution",
      id: "premiumPerFreq",
      rowNumber: 5,
      type: "Input"
    },
    {
      headerTrKey: "form.assuredSum",
      id: "sumAssured",
      rowNumber: 6,
      type: "Input"
    },
    {
      headerTrKey: "form.savingsProfile",
      id: "investmentProfile",
      type: "Select",
      rowNumber: 7,
      dictname: "INVESTMENT_PROFILE",
      dictType: "translate"
    }
  ] as DefaultConfigState[],
  tableType: `Standard`
};

export interface DefaultConfigState {
  headerTrKey: string;
  id: FieldId | FielInvId;
  type: string;
  rowNumber?: number;
  dictname?: string;
  dictType?: string;
}

export interface IInitialValues {
  frequencyCode?: string;
  durationInYears?: number;
  premiumPerFreq?: string;
  sumAssured?: string;
  investmentProfile?: string;
  payments?: undefined | number;
}

export type DefaultConfigType = typeof defaultConfig;
export type InvConfigType = typeof invConfig;
export type InitialCalcConfigType = DefaultConfigType | InvConfigType;
export type FieldId = keyof typeof defaultInitialValues;
export type FielInvId = keyof typeof invInitialValues;

export const templateConfigMap: Record<ProductCategories, InitialCalcConfigType> = {
  INV: invConfig,
  SAV: defaultConfig,
  PENS: defaultConfig,
  CHILD: defaultConfig
};

export const initialValidationsState = Object.keys(defaultInitialValues).map(id => ({
  id,
  result: { invalidMessage: "", isInvalid: false },
  visibility: false
}));

export const validationConfigMap: Record<ProductCategories, typeof standardValidations> = {
  INV: basicValidations,
  SAV: standardValidations,
  PENS: standardValidations,
  CHILD: standardValidations
};
